import React from 'react';

const Logout = () => {
  return <>LOGOUT</>;
};

export default Logout;
